// NOTE: used by send-action-item configuration and as step on review/approval config
import * as React from "react"
import PropTypes from "prop-types"

// fields
import AssigneeWorkflowFields from "components/WorkflowModalForm/fields/AssigneeWorkflowFields/AssigneeWorkflowFields"
import ActionItemsWorkflowFields from "components/WorkflowModalForm/fields/ActionItemsWorkflowFields/ActionItemsWorkflowFields"
import InformTeamWorkflowFields from "components/WorkflowModalForm/fields/InformTeamWorkflowFields/InformTeamWorkflowFields"

const SendActionItemWorkflow = ({
  form,
  actionItemDisabled,
  setActionItemDisabled,
  sendEmail,
  informTeam,
  setInformTeam,
  className,
}) => {
  return (
    <div className={`workflow-card-wrap${className ? " " + className : ""}`}>
      <AssigneeWorkflowFields
        isEmail
        hasEmailText={sendEmail}
      />

      {/* action item */}
      <ActionItemsWorkflowFields
        actionItemDisabled={actionItemDisabled}
        setActionItemDisabled={setActionItemDisabled}
      />

      {/* notify members */}
      <InformTeamWorkflowFields
        form={form}
        informTeam={informTeam}
        setInformTeam={setInformTeam}
      />
    </div>
  )
}

SendActionItemWorkflow.propTypes = {}

export default SendActionItemWorkflow
